import React, { useCallback, useState } from 'react';
import { CHAT_FLOW_STEPS, ChatAPI, useCurrentChat } from '@guuru/chat-web';
import ChatIntentOptions from './ChatIntentOptions';
import SmartFormIntentOptions from './SmartFormIntentOptions';

type ChatMessage = React.ComponentProps<typeof ChatIntentOptions>['message'];
type SmartFormMessage = React.ComponentProps<
  typeof SmartFormIntentOptions
>['message'];

interface ChatRenderIntentSelectionProps {
  message: ChatMessage | SmartFormMessage;
  readOnly: boolean;
  partnerId?: string;
  locale?: string;
  onRunNextStep?: (_: {
    automationBehavior: {
      subscriptionOptionsText: string;
      subscriptionPriority: string;
      subscriptionTarget: string;
      subscriptionAnswer: string;
    };
  }) => void;
}

const ChatRenderIntentSelection = function ({
  message,
  readOnly,
  partnerId = '',
  onRunNextStep = () => {},
  locale = 'en',
}: ChatRenderIntentSelectionProps) {
  const { flowStep } = useCurrentChat();
  const requestIntent = flowStep === CHAT_FLOW_STEPS.requestIntentSelection;
  const [showOptions, setShowOptions] = useState(requestIntent);

  const handleSelection = useCallback(
    (intent: { name: string }) => {
      const automationBehavior =
        ChatAPI.storeRetrieveAutomationBehavior(partnerId);
      setShowOptions(false);
      onRunNextStep({
        automationBehavior: { ...automationBehavior, ...intent },
      });
    },
    [onRunNextStep, partnerId],
  );

  const isSmartForm = message.smartFormStyle === true;
  const IntentOptions = isSmartForm
    ? SmartFormIntentOptions
    : ChatIntentOptions;
  const showMultiIntentOptions = (requestIntent && showOptions) || readOnly;

  return (
    <IntentOptions
      handleSelection={handleSelection}
      languageCode={locale}
      message={message}
      showOptions={showMultiIntentOptions}
      readOnly={readOnly}
    />
  );
};

export default ChatRenderIntentSelection;
